module.exports = __webpack_public_path__ + "src/assets/textures/table_low_DefaultMaterial_BaseColor.png";